import React from 'react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, useDisclosure, Flex, Center } from '@chakra-ui/react'
import { useToastify } from '../../hooks/useToastify'
import { FaAward } from 'react-icons/fa'
import { colors } from '../../utils/colors'
import { buttonStyles } from '../../utils/ui'
import { CopyIcon } from '@chakra-ui/icons'
import { ImAmazon } from 'react-icons/im'
import { Trans, useTranslation } from 'react-i18next'

const ReferralDialog = React.memo(() => {
  const referralsDisclosure = useDisclosure()
  const toast = useToastify()
  const { t } = useTranslation()

  const handleCopyContent = () => {
    navigator.clipboard.writeText(t('referral.referralDialog.shareMessage'))
    toast.success(t('referral.copiedSuccess'), {
      autoClose: 3000
    })
  }

  return (
    <>
      <Button
        justifySelf='end'
        id='referralDialogButton'
        onClick={referralsDisclosure.onOpen}
        bg={colors.tertiary[2]}
        {...buttonStyles}
      >
        {t('referral.button')}
        <FaAward />
      </Button>
      <Modal
        trapFocus={false}
        closeOnOverlayClick={true}
        isOpen={referralsDisclosure.isOpen}
        onClose={referralsDisclosure.onClose}
        isCentered
        size={{
          base: '100%',
          md: '50%'
        }}
      >
        <ModalOverlay />

        <ModalContent
          maxW={{
            base: '100%',
            md: '50%'
          }}
          px={{
            base: 0,
            md: '1rem'
          }}
        >
          <ModalHeader
            px={{
              base: '2rem',
              md: '4rem'
            }}
            textAlign='center'
          >
            {t('referral.title')}
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody>
            <Flex
              flexDir='column'
              gap='1rem'
            >
              <p>{t('referral.description1')}</p>
              <p>
                <Trans
                  i18nKey='referral.description2'
                  components={{ b: <b /> }}
                />
              </p>
              <p>{t('referral.description3')}</p>
            </Flex>

            <Center mt='1rem'>
              <Flex
                _hover={{
                  shadow: 'lg'
                }}
                rounded='md'
                px='4rem'
                py='1.5rem'
                backgroundColor={colors.black}
                align='center'
                maxW='fit-content'
                justifyContent='center' // Center the SVG within the Flex container
                cursor='pointer'
                onClick={handleCopyContent}
                id='referralDialogAmazonBanner'
              >
                <ImAmazon
                  size='4rem'
                  color={colors.white}
                />
              </Flex>
            </Center>
          </ModalBody>

          <ModalFooter justifyContent='center'>
            <Button
              onClick={handleCopyContent}
              variant='ghost'
              gap={2}
              bg={colors.tertiary[3]}
              id='referralDialogCopyContentButton'
              flexWrap='wrap'
            >
              {t('referral.copyText')}
              <CopyIcon />
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
})

export { ReferralDialog }
